/**
 * Constante com os motivos possíveis para a alteração de email.
 * @type {ReasonsChangeEmail}
 */
export const REASONS_CHANGE_EMAIL = [
    { value: 'Sem acesso ao e-mail anterior', label: 'Sem acesso ao e-mail anterior' },
    { value: 'Atualização de e-mail', label: 'Atualização de e-mail' },
    { value: 'Outros', label: 'Outros' },
];

/**
 *
 * @type {AccessPortalPayload}
 */
export const accessPortalPayload = {
    deCpfCnpj: '',
    nmUsuario: '',
    deEmail: '',
    deSenha: '',
    deCep: '',
    uf: '',
    municipio: '',
    deBairro: '',
    deEndereco: '',
    deNumeroEndereco: '',
    deComplemento: '',
    deTelefone: '',
    deObservacao: '',
};

/**
 *
 * @type {ChangeEmailPayload}
 */
export const changeEmailPayload = {
    cdEmpresa: '',
    cdUsuario: '',
    nmUsuario: '',
    deCpfCnpj: '',
    deCep: '',
    deBairro: '',
    deEndereco: '',
    deNumeroEndereco: '',
    deComplemento: '',
    deTelefone: '',
    deMotivo: REASONS_CHANGE_EMAIL[0].value,
    deObservacao: '',
    deEmail: '',
    deNewEmail: '',
    boVisitante: false,
    municipio: {},
    documentos: [],
};

/**
 *
 * @type {RegistrationPayload}
 */
export const registrationPayload = {
    tpCadastro: 'company',
    nuProcesso: '',
    dtVencimentoCrc: '',
    boSituacaoOrgao: '',
    flRepresentacao: 'M',
    deCnpjMatriz: '',
    deCnpjFilial: '',
    deRazaoSocial: '',
    nmFantasia: '',
    cdRamoAtividade: '',
    cdTipoEmpresa: '',
    deEmail: '',
    deObservacao: '',
    deTelefone: '',
    enderecoMatriz: {
        deCep: '',
        uf: '',
        municipio: {},
        deBairro: '',
        deEndereco: '',
        deNumeroEndereco: '',
        deComplemento: '',
        cdMunicipio: '',
    },
    contatos: [],
    documentos: [],
    dtFundacao: '',
    nuEmbratur: '',
    tpRegistro: '',
    deRegistro: '',
    dtRegistro: '',
    nuArquivamento: '',
    dtArquivamento: '',
    tpControleAcionario: '',
    vlCapital: '',
};

/**
 *
 * @type {RegistrationPersonPayload}
 */
export const registrationPersonPayload = {
    tpCadastro: 'person',
    nuProcesso: '',
    dtVencimentoCrc: '',
    boSituacaoOrgao: '',
    cdTipoPessoaFisica: '',
    deCpf: '',
    nmCompleto: '',
    dtNascimento: '',
    deRg: '',
    dtRg: '',
    sgOrgaoRg: '',
    cdUfRg: '',
    deCnh: '',
    dtValidadeCnh: '',
    tpCategoriaCnh: '',
    cdUfCnh: '',
    deFiliacaoPai: '',
    deFiliacaoMae: '',
    nuInss: '',
    deObservacao: '',
    deEmail: '',
    deTelefone: '',
    enderecoPessoa: {
        deCep: '',
        uf: '',
        municipio: {},
        deBairro: '',
        deEndereco: '',
        deNumeroEndereco: '',
        deComplemento: '',
        cdMunicipio: '',
    },
    contatos: [],
    documentos: [],
};

/**
 *
 * @type {VehicleRequestPayload}
 */
export const vehicleRequestPayload = {
    veiculos: [],
    documentos: [],
    deObservacaoExclusao: '',
};

/**
 *
 * @type {VehiclePayload}
 */
export const vehiclePayload = {
    nmOperador: '',
    boProprietario: false,
    nmProprietario: '',
    deCpfCnpjProprietario: '',
    dePlaca: '',
    deRenavam: '',
    nuAnoIpva: '',
    cdCategoriaVeiculo: '',
    deChassi: '',
    nuAnoFabricacao: '',
    cdMarca: '',
    cdModeloVeiculo: '',
    nuAnoModelo: '',
    cdTipoCombustivel: '',
    vlPotenciaMotor: '',
    uf: '',
    municipio: {},
    nuAgerba: '',
    nuOrdemEmpresa: '',
    deObservacao: '',
    qtCapacidade: '',
    deUtilizacao: '',
    cdSubSistema: '',
    cdTipoVeiculo: '',
    cdTipoAcessibilidade: '',
    cdClassificacaoVeiculo: '',
    documentos: [],
};

/**
 *
 * @type {SurveyRequestPayload}
 */
export const surveyRequestPayload = {
    deObservacao: '',
    vistoriaVeiculos: [],
    documentos: [],
};

/**
 *
 * @type {SurveyVehiclePayload}
 */
export const surveyVehiclePayload = {
    cdMunicipioVistoria: null,
    cdVistoriaVeiculo: null,
    cdVistoria: null,
    cdVeiculo: null,
    dtVistoria: null,
    tpSituacao: null,
    boVeiculoAusente: false,
    veiculo: {},
    boVeiculoNovo: false,
    idVistoria: null,
    dtNotaFiscal: null,
    nuValorBem: null,
};

export const inspectionReportPayload = {};

/**
 *
 * @type {LicensePayload}
 */
export const licensePayload = {
    boMatutino: false,
    boVespertino: false,
    boNoturno: false,
    cdLicenca: null,
    cdSolicitacao: null,
    cdSolicitacaoOrigem: null,
    nuAno: null,
    nuLicenca: null,
    deCpfCnpj: '',
    dtViagem: '',
    dtVencimento: '',
    dtRenovacao: '',
    dtRetorno: '',
    nuPeriodicidadeMes: null,
    nuMeses: null,
    frequencyTest: null,
    deResponsavel: '',
    deRgResponsavel: '',
    deObservacao: '',
    cdMunicipioSolicitacao: null,
    cdMunicipioOrigem: null,
    cdMunicipioDestino: null,
    dePreposto: '',
    cdTipoGrupoFixo: '',
    cdTipoAlteracaoLicenca: '',
    documentos: [],
    licencaVeiculos: [],
    passageiros: [],
    itinerario: [],
    horarios: [],
    empresas: [],
    tipoAlteracaoLicenca: null,
};

/**
 *
 * @type {LinePayload}
 */
export const linePayload = {
    documentos: [],
    deCpfCnpj: '',
    nmCompleto: '',
    deJustificativa: '',
    cdLinha: '',
    cdQuadroHorario: '',
    dtCadastro: new Date(),
    dtVencimento: '',
    dtRenovacao: '',
    deTempoServico: '',
    nuTermoPermissao: '',
    deCpfCnpjSucessor: '',
    nmCompletoSucessor: '',
    cdVeiculoAntigo: '',
    cdVeiculo: '',
    condutor: {},
    quadroHorarios: {},
    linha: {},
};

/**
 *
 * @type {LineStripPayload}
 */
export const lineStripPayload = {
    conexao: '',
    deServicoSolicitado: '',
    deJustificativa: '',
    deObservacao: '',
    documentos: [],
    deCpfCnpj: '',
    nmCompleto: '',
    cdLinha: '',
    cdQuadroHorario: '',
    dtCadastro: new Date(),
    dtVencimento: '',
    dtRenovacao: '',
    deTempoServico: '',
    nuTermoPermissao: '',
    deCpfCnpjSucessor: '',
    nmCompletoSucessor: '',
    cdVeiculoAntigo: '',
    cdVeiculo: '',
    condutor: {},
    quadroHorarios: {},
    linha: {},
};
